import { NavLink } from "react-router-dom";
import { MapPin, MessageCircle, PartyPopper, Share2, User, HeartHandshake } from "lucide-react";
import { cn } from "@/lib/utils";

const TABS = [
  { to: "/", label: "Map", icon: MapPin, end: true },
  { to: "/live", label: "Live", icon: MessageCircle },
  { to: "/share", label: "Share", icon: Share2 },
  { to: "/profile", label: "Profile", icon: User },
];

export const AppLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-surface text-ink">
      {/* Desktop sidebar */}
      <aside className="hidden lg:flex fixed inset-y-0 left-0 w-64 flex-col border-r border-border bg-surface-2 p-4 z-40">
        <div className="flex items-center gap-2 px-2 py-4">
          <div className="w-10 h-10 rounded-pill grid place-items-center text-white" style={{ background: "#1E40AF" }}>
            <HeartHandshake size={22} strokeWidth={2.6} />
          </div>
          <div className="leading-tight">
            <div className="font-black text-lg tracking-tight">Blessed</div>
            <div className="text-[11px] text-ink-tertiary font-semibold">Kindness on the map</div>
          </div>
        </div>
        <nav className="flex flex-col gap-1 mt-4">
          {TABS.map((t) => {
            const Icon = t.icon;
            return (
              <NavLink
                key={t.to}
                to={t.to}
                end={t.end}
                data-testid={`nav-${t.label.toLowerCase()}`}
                className={({ isActive }) =>
                  cn(
                    "flex items-center gap-3 px-4 py-3 rounded-lg font-extrabold text-base transition-colors",
                    isActive ? "bg-brand-primary text-white shadow-lg" : "text-ink-tertiary hover:bg-surface-3 hover:text-ink"
                  )
                }
              >
                <Icon size={22} strokeWidth={2.4} />
                <span>{t.label}</span>
              </NavLink>
            );
          })}
        </nav>
      </aside>

      {/* Main */}
      <main className="lg:pl-64 min-h-screen">{children}</main>

      {/* Mobile bottom tabs */}
      <nav
        className="lg:hidden fixed bottom-0 inset-x-0 bg-surface-2 border-t border-border flex items-stretch z-40"
        style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
      >
        {TABS.map((t) => {
          const Icon = t.icon;
          return (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              data-testid={`tab-${t.label.toLowerCase()}`}
              className={({ isActive }) =>
                cn("flex flex-col items-center justify-center gap-0.5 flex-1 py-2.5 transition-colors", isActive ? "text-brand-primary" : "text-ink-tertiary")
              }
            >
              {({ isActive }) => (
                <>
                  <Icon size={24} strokeWidth={isActive ? 2.8 : 2.2} />
                  <span className="text-[11px] font-bold">{t.label}</span>
                </>
              )}
            </NavLink>
          );
        })}
      </nav>
    </div>
  );
};
